/* Dr.Primal — the quiz plan picker (sections/dp-quiz-plan.liquid).

   Two jobs: switch which offer group is visible (one-time / subscribe), and add the
   clicked card's line to the basket. The add is dp-purchase-options' contract, kept
   deliberately identical: one line, Liquid-stamped ids only, then reconcile the basket
   against the card's advertised TOTAL — a typed total is a promise about an automatic
   discount in the admin, and a basket that charges more raises DPCartGuard and blocks
   checkout rather than letting the mismatch through. Nothing here formats money.

   Every card carries its own Order button, so there is no selection state to keep. */
(function () {
  'use strict';

  var SECTIONS = 'dp-cart-drawer,dp-header';

  var root = null;
  var errorNode = null;
  var busy = false;

  function shopRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function guard() {
    return window.DPCartGuard || null;
  }

  function message(name) {
    return root.getAttribute('data-dp-msg-' + name) || '';
  }

  function clearError() {
    if (!errorNode) return;
    errorNode.hidden = true;
    errorNode.textContent = '';
  }

  function showError(text) {
    if (!errorNode) return;
    errorNode.textContent = text;
    errorNode.hidden = false;
  }

  function readJson(response) {
    return response.json().then(
      function (body) {
        if (response.ok) return body;
        var detail = body && (body.description || body.message);
        throw new Error(detail || message('error'));
      },
      function () {
        throw new Error(message('error'));
      }
    );
  }

  function getCart() {
    return window
      .fetch(shopRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(readJson);
  }

  function planOfLine(line) {
    return line.selling_plan_allocation && line.selling_plan_allocation.selling_plan
      ? String(line.selling_plan_allocation.selling_plan.id)
      : '';
  }

  function lineFor(cart, variantId, plan) {
    for (var i = 0; i < cart.items.length; i += 1) {
      var line = cart.items[i];
      if (String(line.variant_id) === String(variantId) && planOfLine(line) === String(plan || '')) {
        return line;
      }
    }
    return null;
  }

  /* dp-purchase-options' reconcile, verbatim in behaviour: the line must exist for the
     variant AND plan we posted, and our quantity of it must cost no more than the card
     advertised. One-sided on purpose — a cheaper basket is the customer's good day. */
  function reconcile(context) {
    var problems = [];
    var variants = [];

    var line = lineFor(context.after, context.variantId, context.plan);
    if (!line) {
      problems.push(
        'no line for variant ' + context.variantId + ' carrying plan "' + (context.plan || '') + '"'
      );
      variants.push({ id: context.variantId });
    } else {
      var perUnit = line.quantity ? line.final_line_price / line.quantity : line.final_line_price;
      var forOurQuantity = Math.round(perUnit * context.quantity);
      if (forOurQuantity > context.advertised) {
        problems.push(
          'line costs ' + forOurQuantity + ' for ' + context.quantity + ', advertised ' + context.advertised
        );
        variants.push({ id: context.variantId, plan: context.plan || '' });
      }
    }

    return { ok: problems.length === 0, problems: problems, variants: variants };
  }

  function setBusy(state) {
    busy = state;
    Array.prototype.forEach.call(root.querySelectorAll('[data-dp-qp-add]'), function (button) {
      button.disabled = state;
    });
  }

  function add(trigger, card) {
    if (busy) return;
    if (card.getAttribute('data-dp-available') !== 'true') return;

    clearError();
    setBusy(true);

    var variantId = card.getAttribute('data-dp-variant');
    var plan = card.getAttribute('data-dp-plan') || '';
    var quantity = parseInt(card.getAttribute('data-dp-qty'), 10) || 1;
    var expected = parseInt(card.getAttribute('data-dp-total'), 10);

    var line = { id: variantId, quantity: quantity };
    if (plan) line.selling_plan = plan;

    var posted = false;
    var added = null;

    window
      .fetch(shopRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [line],
          sections: SECTIONS,
          sections_url: window.location.pathname + window.location.search,
        }),
      })
      .then(function (response) {
        if (response.ok) posted = true;
        return readJson(response);
      })
      .then(function (result) {
        added = result;
        return getCart().then(function (after) {
          return { result: result, after: after };
        });
      })
      .then(function (payload) {
        var verdict = reconcile({
          after: payload.after,
          advertised: expected,
          variantId: variantId,
          plan: plan,
          quantity: quantity,
        });

        var detail = { sections: payload.result.sections, open: verdict.ok };
        if (verdict.ok) {
          detail.trigger = trigger;
          document.dispatchEvent(
            new CustomEvent('dp:atc', {
              detail: {
                variantId: variantId,
                quantity: quantity,
                plan: plan,
                value: expected / 100,
                currency: payload.after.currency,
                eventId: 'dp-qp-' + payload.after.token + '-' + Date.now(),
              },
            })
          );
        } else {
          console.error('[dp-quiz-plan] reconciliation failed:', verdict.problems.join('; '));
          showError(message('mismatch'));
          if (guard()) guard().raise(message('blocked'), verdict.variants, payload.after.token);
        }

        document.dispatchEvent(new CustomEvent('dp:cart:updated', { detail: detail }));
      })
      .catch(function (error) {
        console.error('[dp-quiz-plan]', error);

        if (!posted) {
          showError(error.message || message('error'));
          return;
        }

        // The line IS in the basket and its cost could not be confirmed: block
        // checkout and say so — leaving the flag up is the safe failure.
        showError(message('unverified'));
        if (guard()) guard().raise(message('blocked'), [{ id: variantId }]);

        if (added && added.sections) {
          document.dispatchEvent(
            new CustomEvent('dp:cart:updated', { detail: { sections: added.sections, open: false } })
          );
        }
      })
      .then(function () {
        setBusy(false);
      });
  }

  function publishCta(card) {
    try {
      if (!window.dpGa4) return;
      var group = card.closest('[data-dp-qp-group]');
      var total = parseInt(card.getAttribute('data-dp-total'), 10);
      window.dpGa4.event('quiz_cta_click', {
        cta: 'order',
        plan_mode: group ? group.getAttribute('data-dp-qp-group') : '',
        plan_months: parseInt(card.getAttribute('data-dp-months'), 10) || 0,
        value: total ? total / 100 : 0,
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '',
      });
    } catch (error) {
      console.error('[dp-quiz-plan] publish failed', error);
    }
  }

  function setMode(mode) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-dp-qp-mode-btn]'), function (button) {
      button.setAttribute(
        'aria-pressed',
        button.getAttribute('data-dp-qp-mode-btn') === mode ? 'true' : 'false'
      );
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-dp-qp-group]'), function (group) {
      group.hidden = group.getAttribute('data-dp-qp-group') !== mode;
    });
  }

  function init() {
    root = document.querySelector('[data-dp-qp]');
    if (!root) return;

    errorNode = root.querySelector('[data-dp-qp-error]');

    if (root.hasAttribute('data-dp-qp-inline')) {
      var slot = document.querySelector('[data-dp-po-slot]');
      if (slot && !slot.contains(root)) slot.appendChild(root);
    }

    root.addEventListener('click', function (event) {
      if (!(event.target instanceof window.Element)) return;

      var modeButton = event.target.closest('[data-dp-qp-mode-btn]');
      if (modeButton) {
        setMode(modeButton.getAttribute('data-dp-qp-mode-btn'));
        return;
      }

      var trigger = event.target.closest('[data-dp-qp-add]');
      if (trigger) {
        var card = trigger.closest('[data-dp-qp-card]');
        if (card) {
          publishCta(card);
          add(trigger, card);
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
